import React from "react";
import { Alert, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import type { AccountCreationSideEffects } from "../../redux/types/Authentication";
import { VCard } from "../ui";

type Props = {
    email: string;
    result: AccountCreationSideEffects;
};

const RegistrationSuccess: React.FC<Props> = ({ email, result }) => {
    const { t } = useTranslation();

    return (
        <VCard variant="well">
            <Row>
                <Col xs={12}>
                    <h3 className="text-center">
                        {t(
                            "Check your email to finish setting up your account"
                        )}
                    </h3>
                </Col>
                <Col xs={12}>
                    <p>
                        {t("We sent a verification link to")}{" "}
                        <strong>{email}</strong>.
                    </p>
                    {result.billingSynchronizationStatus === "FAILED" && (
                        <Alert variant="warning">
                            {t(
                                "Billing setup is still processing. This will not prevent you from activating your account."
                            )}
                        </Alert>
                    )}
                    <p>
                        {t(
                            "Open the email and follow the verification link to activate your account."
                        )}
                    </p>
                    <p>
                        {t(
                            "If the email does not arrive within a few minutes, check your spam folder."
                        )}
                    </p>
                    <p>
                        <a href="/">{t("Return to sign in")}</a>
                    </p>
                    <p>
                        <a href="https://www.viridischem.com/">
                            {t("Visit ViridisChem")}
                        </a>
                    </p>
                </Col>
            </Row>
        </VCard>
    );
};

export default RegistrationSuccess;
